import { createContext, useContext } from 'react';

import type { MediaProvider } from '@atlaskit/editor-common/provider-factory';
import type { AuthProvider } from '@atlaskit/media-core';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri, HelpPageAri } from '@atlassian/ari';

import type { HubContextType } from './types';

export const getAuthProvider =
	(asapIssuer: string, mediaToken: string, mediaUrl: string): AuthProvider =>
	async () => {
		return {
			asapIssuer,
			token: mediaToken,
			baseUrl: mediaUrl,
		};
	};

export const getMediaProvider = (
	mediaCollectionName: string,
	asapIssuer: string,
	mediaToken: string,
	mediaUrl: string,
): MediaProvider => ({
	uploadParams: {
		collection: mediaCollectionName,
	},
	viewMediaClientConfig: {
		authProvider: getAuthProvider(asapIssuer, mediaToken, mediaUrl),
		useSha256ForUploads: true,
	},
});

const getSafeHelpCenterIdMeta = (helpCenterAri: string): { activationId: string, helpCenterId: string } | undefined => {
    try {
        if (helpCenterAri && helpCenterAri !== 'null') {
            const { activationId, helpCenterId } = HelpHelpCenterAri.parse(helpCenterAri);
			return { activationId, helpCenterId }
        }
    } catch (error) {
		// todo: add analytics
    }
};

export const getPageAri = (helpCenterAri: string, pageId: string): string => {
    const { activationId = '', helpCenterId = '' } = getSafeHelpCenterIdMeta(helpCenterAri) || {};
    return (
        HelpPageAri.create({
            activationId: activationId,
            pageId: pageId || helpCenterId,
        }).toString() || ''
    );
};

export const HubContext = createContext<HubContextType | null>(null);

export const useHubContext = () => {
	const context = useContext(HubContext);
	if (!context) {
		throw new Error('useHubContext must be used within a HubContextProvider');
	}
	return context;
};
